import React from "react";
import { ToastContainer, Slide, ToastContainerProps } from "react-toastify";

import "./global-toast.scss";

interface IToastProps extends ToastContainerProps {}

const ToastProvider = (_props: IToastProps) => (
  <ToastContainer className="toaster-bf" transition={Slide} position="bottom-right" draggable />
);

export { ToastProvider };
